import { Box, Flex, Text } from "@chakra-ui/react";

import { Button } from "@components/ui/button";

import { openPlanSelection } from "@utils/monday-plans";

const SubscribePage = () => {
  return (
    <Box
      minHeight="100vh"
      px="4"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Flex
        direction="column"
        maxW="3xl"
        mx="auto"
        textAlign="start"
      >
        <Text
          fontSize="xl"
          fontWeight="medium"
        >
          Choose a plan to continue using QuickBooks for monday.com
        </Text>

        <Button
          size="md"
          w="full"
          mt="4"
          colorPalette="blue"
          onClick={openPlanSelection}
        >
          Choose a plan
        </Button>

        <Text
          fontSize="sm"
          color="gray.500"
          textAlign="center"
          mt="4"
        >
          If you’ve subscribed to a plan, please refresh this browser window
        </Text>
      </Flex>
    </Box>
  );
};

export default SubscribePage;
